<div class="col-sm-12 detail" *ngIf="!isEmpty" style="height: 100%" (click)="common.outSide($event)">
  <div class="header col-sm-12">
    <div class="col-sm-8">
      <h2> Liste des utilisateurs Ecoportail du client : {{ detail ? detail.nomclient || '' : '' }} </h2>
    </div>
    <div class="col-sm-4 text-right">
      <button class="btn-header uppercase closeUserEcoportail" id="close" (click)="hide()"> Fermer</button>
      <button class="btn-header uppercase actionPricipal" id="valide" (click)="update()"> Valider</button>
      <!--div>
        <label class="text-left uppercase text-underline historique" (click)="common.getLogs(detail.id, '43', modalService);"> Voir l'historique </label>
        <label class="text-left uppercase text-underline historique">Voir les documents</label>
      </div-->
    </div>
  </div>

  <div class="col-sm-4" style="padding: 0;">
    <span class="input-group recherche" style="padding: 2px 1px">
        <input  class="form-control"  (keydown.enter)="searchHandle()" style=" height: 42px"
            [(ngModel)]="search" [ngClass]="{'focus focusBorderRight': focus}" type="search" (focus)="focus = !focus" (blur)="focus = !focus" placeholder="Rechercher">
        <span class="input-group-addon " id="basic-addon1" [ngClass]="{'focus focusBorderLeft': focus}" (click)="searchHandle()">
          <span class="glyphicon glyphicon-search"></span>
        </span>    
    </span>
  </div>
  <div class="col-sm-12 ligneBon liste">
    <ngx-datatable  style="height: 100%" class="material" [rows]="listUserEcoportail || []"
                   [columnMode]="'force'" [headerHeight]="35" [footerHeight]="nbPage > 1 ? '50' : '0'" [rowHeight]="30" [selectionType]="'checkbox'"
                   [messages]="{emptyMessage: 'Pas de lignes à afficher'}"
                   [loadingIndicator]="loadingIndicator" [selected]="selected" >

      <ngx-datatable-column name="login">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sortBy('u.login')">
            <span class="uppercase">Login</span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <input type="text" class="input detailfact" id="login{{rowIndex}}" placeholder="Login" [(ngModel)]="row.login"
                 (ngModelChange)="row.isEdit = true;" autocomplete="off"
                 (keydown.enter)="common.focusNext('.ligneBon')">
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="pwd">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader text-right">
            <span class="uppercase"> Mot de passe </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <input [type]="getPasswordType(row)" class="input detailfact" id="login{{rowIndex}}" placeholder="Mot de passe"
                 [(ngModel)]="row.nouvelleMDP"
                 (ngModelChange)="row.isEdit = true;" autocomplete="off"
                 (keydown.enter)="common.focusNext('.ligneBon')">
                 <span class="eye-icon" *ngIf="row.nouvelleMDP" (click)="togglePasswordVisibility(row)">
                  <i class="fa" [ngClass]="{'fa-eye': !row.showPwd, 'fa-eye-slash': row.showPwd}"></i>
                </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="mail">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sortBy('u.mail')">
            <span class="uppercase">mail</span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <input type="text" class="input detailfact" id="mail{{rowIndex}}" placeholder="mail" [(ngModel)]="row.mail"
                 (ngModelChange)="row.isEdit = true;" autocomplete="off"
                 (keydown.enter)="common.focusNext('.ligneBon')">
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Chantier" prop="agence.libelle">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sortBy('u.nom')">
            <span class="uppercase"> Agence </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <app-autocomplete [placeholder]="''" (selectfunction)="row.agence = $event;row.isEdit = true;"
                            [results]="listeAgence"
                            [label]="''" [defaultselected]="row.agence" [container]="true"
                            [id]="classPresta + 'btncombo agence' + rowIndex" [disablefocus]="true"
                            [isCombo]="true" [highlight]="true"
                            [defaultsearch]="value || (row.agence ? row.agence.libelleObjetEntite || row.agence.libelle : '')"></app-autocomplete>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Chantier" prop="chantier.numChantier">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sortBy('c.numChantier')">
            <span class="uppercase"> Chantier </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <app-autocomplete [placeholder]="row.chantier ? '' : 'Chantier'" (searchfunction)="searchChantier($event)"
                            *ngIf="!isDepuisFicheDetenteur"
                            (selectfunction)="row.chantier = $event;row.isEdit = true;"
                            [notOblig]="true" [label]="''" [selectvalue]="true" [container]="true" [showonclick]="true"
                            [results]="listChantier" [id]="classPresta + ' chantier' + rowIndex"
                            [defaultsearch]="value || row.chantier.libelleObjetEntite" [autohide]="true"
                            [disablefocus]="true"
                            (keyenterfunction)="common.focusNext('.ligneBon');"></app-autocomplete>
          <div class="text-center" *ngIf="isDepuisFicheDetenteur">
            {{ chantier.numChantier }}
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="site" prop="site.nom">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sortBy('su.Site')">
            <span class="uppercase"> Site </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <app-autocomplete [placeholder]="row.site ? '' : 'Site'" (searchfunction)="searchSite($event)"
                            (selectfunction)="row.site = $event;row.isEdit = true;"
                            [notOblig]="true" [label]="''" [selectvalue]="true" [container]="true" [showonclick]="true"
                            [results]="listSite" [id]="classPresta + ' comboIndispo site' + rowIndex" [isCombo]="true"
                            [defaultsearch]="value || (row.site ? row.site.nom || row.site.libelleObjetEntite : '')" [autohide]="true"
                            [disablefocus]="true"
                            (keyenterfunction)="common.focusNext('.ligneBon');"></app-autocomplete>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Unite" prop="unite.libelle">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader text-center" (click)="sortBy('u.isDocSsChantierAgence')">
            <span class="uppercase"> Doc ss Chant/Ag </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div class="strong text-center" style="overflow:hidden">
            <mat-checkbox [color]="'primary'" [(ngModel)]="row.isDocSsChantierAgence"
                          (ngModelChange)="row.isEdit = true;"></mat-checkbox>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Tarif" prop="tarif">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sortBy('u.isDocumentsUser')">
            <span class="uppercase "> Documents </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div class="strong text-center" style="overflow:hidden">
            <mat-checkbox [color]="'primary'" [(ngModel)]="row.isDocumentsUser"
                          (ngModelChange)="row.isEdit = true;"></mat-checkbox>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="TxTVA" prop="txTVA">
        <ng-template let-col="column" ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                     let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sortBy('u.isLibraDataUser')">
            <span class="uppercase">Libra Data</span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div class="strong text-center" style="overflow:hidden">
            <mat-checkbox [color]="'primary'" [(ngModel)]="row.isLibraDataUser"
                          (ngModelChange)="row.isEdit = true;"></mat-checkbox>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="MontantHT" prop="prixHT">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sortBy('u.isPriseCommandeUser')">
            <span class="uppercase"> Prise de commande </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div class="strong text-center" style="overflow:hidden">
            <mat-checkbox [color]="'primary'" [(ngModel)]="row.isPriseCommandeUser"
                          (ngModelChange)="row.isEdit = true;"></mat-checkbox>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="DateDebut" prop="dateDebut">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sortBy('u.isDemande')">
            <span class="uppercase"> Demandes </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div class="strong text-center" style="overflow:hidden">
            <mat-checkbox [color]="'primary'" [(ngModel)]="row.isDemande"
                          (ngModelChange)="row.isEdit = true;"></mat-checkbox>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="DateFin" prop="dateFin">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sortBy('u.isDesactive')">
            <span class="uppercase"> Désactivé </span>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div class="strong text-center" style="overflow:hidden">
            <mat-checkbox [color]="'primary'" [(ngModel)]="row.isDesactive"
                          (ngModelChange)="row.isEdit = true;"></mat-checkbox>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template let-pageSize="pageSize" let-selectedCount="selectedCount"
            let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
            <datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'"
                [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'"
                [pagerNextIcon]="'datatable-icon-skip'" [page]="page
                +1" [size]="50" [count]="rowCount"
                [hidden]="!((rowCount /50) > 1)" (change)="onFooterPage($event)">
            </datatable-pager>
        </ng-template>
    </ngx-datatable-footer>


    </ngx-datatable>
  </div>
  <div class="addLigne col-sm-12 uppercase">
    <div class="col-sm-7 text-left">
      <button class="btn-add" id="addLigne" (click)="addLigne()">
        <i class="fa fa-plus"></i>
      </button>
      <span (click)="addLigne()">Ajouter une ligne</span>

    </div>
    <label class="text-left uppercase text-underline historique col-sm-5"></label>
  </div>
</div>

<app-empty-detail-fact *ngIf="isEmpty" id="empty"></app-empty-detail-fact>

